import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CycleDal } from '../dal/cycle.dal';
import { cycle } from '../models/cycle.model';
import { cycleCalendar } from '../models/cycleCalendar.model';

@Injectable({
  providedIn: 'root',
})
export class CycleService {
  constructor(private cycleDAL: CycleDal) {}

  checkConflicts(fromDate: string, toDate: string, cycle: cycle): Observable<any> {
    return this.cycleDAL.checkConflicts(fromDate, toDate, cycle);
  }

  getEffectif(week: number, cycleId: string): Observable<any> {
    return this.cycleDAL.getEffectif(week, cycleId);
  }

  getCycleNightEffectifNeeds(cycleId: string): Observable<any> {
    return this.cycleDAL.getCycleNightEffectifNeeds(cycleId);
  }

  deleteCycle(cycle: cycle): Observable<any> {
    return this.cycleDAL.deleteCycle(cycle);
  }

  deleteCalendar(cycleCalendar: cycleCalendar): Observable<any> {
    return this.cycleDAL.deleteCalendar(cycleCalendar);
  }

  updateCycleCalendar(calendar: cycleCalendar): Observable<any> {
    return this.cycleDAL.updateCycleCalendar(calendar);
  }

  createCycleCalendar(calendar: cycleCalendar): Observable<any> {
    return this.cycleDAL.createCycleCalendar(calendar);
  }

  createCycleWeekType(cycleWeekType: any): Observable<any> {
    return this.cycleDAL.createCycleWeekType(cycleWeekType);
  }

  updateCycleWeekType(cycleWeekType: any): Observable<any> {
    return this.cycleDAL.updateCycleWeekType(cycleWeekType);
  }

  getAllCycleWeekTypes(): Observable<any> {
    return this.cycleDAL.getAllCycleWeekTypes();
  }

  getAllCycleWeekTypeNames(): Observable<any> {
    return this.cycleDAL.getAllCycleWeekTypeNames();
  }

  editCalendarsFromWeekType(data: any): Observable<any> {
    return this.cycleDAL.editCalendarsFromWeekType(data);
  }

  deleteWeekType(weekTypeId: string): Observable<any> {
    return this.cycleDAL.deleteWeekType(weekTypeId);
  }

  getCalendarsOfCycle(_id: string, cycle: cycle, weekNumbers: number, getWeekType?: boolean): Observable<any> {
    return this.cycleDAL.getCalendarsOfCycle(_id, cycle, weekNumbers, getWeekType);
  }

  getCycles(positions?: string[], isNight?: boolean): Observable<any> {
    return this.cycleDAL.getCycles(positions, isNight);
  }

  getCycleById(cycleId: string): Observable<any> {
    return this.cycleDAL.getCycleById(cycleId);
  }

  getWeekTypeWithCalendars(nurseIds: string[], cycleId: string): Observable<any> {
    return this.cycleDAL.getWeekTypeWithCalendars(nurseIds, cycleId);
  }

  getCyclesCampaign(position?: string[], isNight?: boolean, campaignId?: string): Observable<any> {
    return this.cycleDAL.getCyclesCampaign(position, isNight, campaignId);
  }

  generateCalendars(startDate: any, endDate: any, cycle: cycle, keepOldCalendars: boolean): Observable<any> {
    return this.cycleDAL.generateCycle(startDate, endDate, cycle, keepOldCalendars);
  }

  generateProfiledCalendars(
    startDate: any,
    endDate: any,
    cycle: cycle,
    keepOldCalendars: boolean,
    profileIds: string[],
    startingWeekNumber?: number
  ): Observable<any> {
    return this.cycleDAL.generateProfiledCalendars(
      startDate,
      endDate,
      cycle,
      keepOldCalendars,
      profileIds,
      startingWeekNumber
    );
  }

  createCycle(cycle: cycle, cycleSourceId: string): Observable<any> {
    return this.cycleDAL.createCycle(cycle, cycleSourceId);
  }

  updateOptimCycle(cycleId: string, isNight: boolean): Observable<any> {
    return this.cycleDAL.updateOptimCycle(cycleId, isNight);
  }

  editCycle(cycle: cycle): Observable<any> {
    return this.cycleDAL.editCycle(cycle);
  }

  editCycleComments(cycle: cycle): Observable<any> {
    return this.cycleDAL.editCycleComments(cycle);
  }

  updatePeriodAvailabilityCycle(calendar: cycleCalendar, indexes: number[]): Observable<any> {
    return this.cycleDAL.updatePeriodAvailabilityCycle(calendar, indexes);
  }

  deletePeriodCycle(calendar: cycleCalendar, indexes: number[]): Observable<any> {
    return this.cycleDAL.deletePeriodCycle(calendar, indexes);
  }
}
